<template>
      <div class="modal fade" :id="'popUpPratica'+ts" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="sidenav"  id="mySidenav"  >
            <div class="modal-header " style="height:61px;background-color: #ffad69;">    
                <h4 class="modal-title"><i class="fal fa-search"></i> Aggiungi 
                    <span v-if="tipoVisualizzazioneNav == 1">Intestatario</span>
                    <span v-if="tipoVisualizzazioneNav == 2">Pratica</span>
                    <span v-if="tipoVisualizzazioneNav == 3">Terreno</span>
                <button onclick="utils.closeNav()" type="button" class="close float-right" ><span aria-hidden="true">&times;</span></button></h4>
            </div>
            <div class="modal-body" >
                <div v-show="tipoVisualizzazioneNav == 1">
                    <form  autocomplete="off">            
                        <div class="row">
                            <div class="form-group col-md-12" style="margin-bottom:.4rem">
                                <label style="margin-bottom: 0.0rem;">Denominazione</label>
                                <input type="text" class="form-control" v-model="searchIntestatariSelezionabili.DENOMINAZIONE.VALUE">
                            </div> 
                        </div>
                    </form>
                    <ul class="list-group mt-4">
                        <li v-for="intestatario in paginatedListSelezionabili.arr" v-show="intestatario.SELEZIONATO != 1 " v-on:click="addIntestatario(intestatario)" v-bind:key="intestatario" class="list-group-item">
                            <i class="fal mr-1" v-bind:class="{'fa-user':intestatario.ID_PERSONA_FISICA > 0,'fa-university':intestatario.ID_PERSONA_GIURIDICA > 0}"></i>{{ intestatario.DENOMINAZIONE }}
                        </li>
                    </ul>                    
                </div>
                <div v-show="tipoVisualizzazioneNav == 2">
                    <form  autocomplete="off">            
                        <div class="row">
                            <div class="form-group col-md-4" style="margin-bottom:.4rem">
                                <label style="margin-bottom: 0.0rem;">ID Pratica</label>
                                <input type="text" class="form-control" v-model="searchPraticheCollegabili.ID_PRATICA.VALUE">
                            </div> 
                            <div class="form-group col-md-8" style="margin-bottom:.4rem">
                                <label style="margin-bottom: 0.0rem;">Titolo</label>
                                <input type="text" class="form-control" v-model="searchPraticheCollegabili.TITOLO.VALUE">
                            </div> 
                        </div>
                    </form>
                    <ul class="list-group mt-4">
                        <li v-for="p in paginatedListPratiche.arr" v-show="p.SELEZIONATO != 1 " v-on:click="addPraticaCollegata(p)" v-bind:key="p" class="list-group-item">
                            <i class="mr-1" v-bind:class="p.ICONA"></i><strong>[{{ p.ID_PRATICA }}]</strong> {{ p.TITOLO }}
                        </li>
                    </ul>                    
                </div>
                <div v-show="tipoVisualizzazioneNav == 3">
                    <form  autocomplete="off">            
                        <div class="row">
                            <div class="form-group col-md-2" style="margin-bottom:.4rem">
                                <label style="margin-bottom: 0.0rem;">Appezz</label>
                                <input type="text" class="form-control" v-model="searchTerreniCollegabili.ID_APPEZZAMENTO.VALUE">
                            </div> 
                            <div class="form-group col-md-3" style="margin-bottom:.4rem">
                                <label style="margin-bottom: 0.0rem;">Località</label>
                                <input type="text" class="form-control" v-model="searchTerreniCollegabili.LOCALITA.VALUE">
                            </div> 
                            <div class="form-group col-md-4" style="margin-bottom:.4rem">
                                <label style="margin-bottom: 0.0rem;">Cognome</label>
                                <input type="text" class="form-control" v-model="searchTerreniCollegabili.COGNOME.VALUE">
                            </div> 
                            <div class="form-group col-md-3" style="margin-bottom:.4rem">
                                <label style="margin-bottom: 0.0rem;">Nome</label>
                                <input type="text" class="form-control" v-model="searchTerreniCollegabili.NOME.VALUE">
                            </div> 
                        </div>
                    </form>
                    <ul class="list-group mt-4">
                        <li v-for="t in paginatedListTerreni.arr" v-show="t.SELEZIONATO != 1 " v-on:click="addTerrenoCollegato(t)" v-bind:key="t" class="list-group-item">
                            <strong>[{{ t.ID_APPEZZAMENTO }}]</strong> {{ t.LOCALITA }}
                            <br>
                            <small>{{ t.COGNOME }} {{ t.NOME }}</small>
                        </li>
                    </ul>                    
                </div>                
            </div>
        </div>
        <div class="modal-dialog" style="min-width:1200px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header" style="background-color: #ffad69;">
                    <h4 style="color:#fff" class="modal-title"><kbd><i class="fas fa-folder-open"></i> <strong>Pratica</strong> {{ praticaSelezionata.ID_PRATICA }}</kbd> <span v-show="praticaSelezionata.ID_PRATICA > 0"> Ultima modifica: {{ praticaSelezionata.DATA_ULTIMA_MODIFICA }}</span></h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" >  
                    <ul class="nav nav-tabs" id="tabs" role="tablist" style="margin-top:4px">
                        <li class="nav-item">
                            <a class="nav-link isprint-tab pratiche active" style="padding: 0.5rem 0.8rem;" :id="'linkgenerale'+ts" data-toggle="tab" :data-tab="'generale'+ts" :href="'#generale'+ts"  role="tab" :aria-controls="'generale'+ts" aria-selected="true">
                                <i class="fal fa-fw fa-folder"></i> Generale
                            </a>
                        </li>
                        <li class="nav-item" v-show="praticaSelezionata.ID_PRATICA > 0">
                            <a class="nav-link isprint-tab pratiche "  style="padding: 0.5rem 0.8rem;"  data-toggle="tab" :data-tab="'intestatari'+ts" :href="'#intestatari'+ts"  role="tab" :aria-controls="'intestatari'+ts" aria-selected="true">
                                <i class="fal fa-fw fa-tags"></i> Intestatari <span  v-if="praticaSelezionata.intestatari != undefined && praticaSelezionata.intestatari.length > 0" style="font-size:12px" class="badge badge-pill badge-dark">{{ praticaSelezionata.intestatari.length }}</span>
                            </a>
                        </li>
                        <li class="nav-item" v-show="praticaSelezionata.ID_PRATICA > 0">
                            <a class="nav-link isprint-tab pratiche "  style="padding: 0.5rem 0.8rem;"  data-toggle="tab" :data-tab="'allegati'+ts" :href="'#allegati'+ts"  role="tab" :aria-controls="'allegati'+ts" aria-selected="true">
                                <i class="fal fa-fw fa-paperclip"></i> Allegati <span v-if="praticaSelezionata.allegati != undefined && praticaSelezionata.allegati.length > 0"  style="font-size:12px" class="badge badge-pill badge-dark"> {{ praticaSelezionata.allegati.length }}</span>
                            </a>
                        </li>
                        <li class="nav-item" v-show="praticaSelezionata.ID_PRATICA > 0">
                            <a class="nav-link isprint-tab pratiche "  style="padding: 0.5rem 0.8rem;"  data-toggle="tab" :data-tab="'storico'+ts" :href="'#storico'+ts"  role="tab" :aria-controls="'storico'+ts" aria-selected="true">
                                <i class="fal fa-clipboard-list-check"></i> Log azioni <span  v-if="praticaSelezionata.azioni != undefined && praticaSelezionata.azioni.length > 0"  style="font-size:12px" class="badge badge-pill badge-dark"> {{ praticaSelezionata.azioni.length  }}</span>
                            </a>
                        </li>
                        <li class="nav-item" v-show="praticaSelezionata.ID_PRATICA > 0">
                            <a class="nav-link isprint-tab pratiche "  style="padding: 0.5rem 0.8rem;"  data-toggle="tab" :data-tab="'collegate'+ts" :href="'#collegate'+ts"  role="tab" :aria-controls="'collegate'+ts" aria-selected="true">
                                <i class="fas fa-folder-tree"></i> Pratiche collegate <span  v-if="praticaSelezionata.azioni != undefined && praticaSelezionata.praticheCollegate.length > 0"  style="font-size:12px" class="badge badge-pill badge-dark"> {{ praticaSelezionata.praticheCollegate.length  }}</span>
                            </a>
                        </li>
                        <li class="nav-item" v-show="praticaSelezionata.ID_PRATICA > 0">
                            <a class="nav-link isprint-tab pratiche "  style="padding: 0.5rem 0.8rem;"  data-toggle="tab" :data-tab="'terreni'+ts" :href="'#terreni'+ts"  role="tab" :aria-controls="'storico'+ts" aria-selected="true">
                                <i class="fal fa-clipboard-list-check"></i> Terreni <span  v-if="praticaSelezionata.azioni != undefined && praticaSelezionata.azioni.length > 0"  style="font-size:12px" class="badge badge-pill badge-dark"> {{ praticaSelezionata.terreni.length  }}</span>
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" :id="'generale'+ts" role="tabpanel" :active="activeTab === 'Generale'">
                            <div class="form-group row mt-4">
                                <div class="form-group col-md-12" style="margin-bottom:.50rem">
                                    <label>Titolo</label>
                                    <input type="text" class="form-control" v-model="praticaSelezionata.TITOLO">
                                </div>     
                                <div class="form-group col-md-12" style="margin-bottom:.50rem">
                                    <label>Tipologia</label>
                                    <select class="form-control " v-model="praticaSelezionata.FK_ID_TIPO">
                                        <option v-for="tipologia in this.$root.arrayTipologiePratica" v-bind:value="tipologia.ID_TIPOLOGIA" v-bind:key="tipologia.ID_TIPOLOGIA">
                                        {{ tipologia.DESCRIZIONE}}
                                        </option>
                                    </select>
                                </div> 
                                <div class="form-group col-md-12" style="margin-bottom:.50rem">
                                    <label>Stato</label>
                                    <select class="form-control " v-model="praticaSelezionata.FK_ID_STATO">
                                        <option  value="">Nessuno</option>
                                            <option v-for="stato in this.arrayStati" v-bind:value="stato.ID_STATO" v-bind:key="stato.ID_STATO">
                                            {{ stato.DESCRIZIONE}}
                                        </option>
                                    </select>
                                </div> 
                                
                                <div class="form-group col-md-12" style="margin-bottom:.50rem">
                                    <label>Note</label>
                                    <textarea type="text" class="form-control" v-model="praticaSelezionata.NOTE"></textarea>
                                </div> 
                            </div>
                        </div>
                        <div class="tab-pane" :id="'intestatari'+ts" role="tabpanel">
                            <div class="row w-100 mt-4">
                                <div class="col-8">
                                    <div class="form-group" style="margin-bottom:.4rem;">
                                        <label style="margin-bottom: 0.0rem;">Denominazione</label>
                                        <input type="text" class="form-control" v-model="searchIntestatari.DENOMINAZIONE.VALUE">
                                    </div> 
                                </div>
                                <div class="col-4">
                                    <div class="dropdown float-right mt-4" >
                                        <button class="btn btn-success dropdown-toggle" type="button"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fal fa-bolt"></i> Aggiungi intestatari
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                            <button class="dropdown-item" v-on:click="openRicerca()" type="button"><i class="fa-fw fal fa-search"></i> Ricerca</button>
                                            <button class="dropdown-item" v-on:click="nuovaPersonaFisica()" type="button"><i class="fa-fw fal fa-user"></i> Nuova persona</button>
                                            <button class="dropdown-item" v-on:click="nuovaPersonaGiuridica()" type="button"><i class="fa-fw fal fa-university"></i> Nuova società</button>
                                        </div>
                                    </div> 
                                </div>
                            </div>
                            <div class="row w-100 mt-4">
                                <div class="col-12">
                                    <ul class="list-group">
                                        <li class="list-group-item" v-for="intestatario in paginatedListIntestatari.arr" v-bind:key="intestatario">
                                            <div class="float-left pt-2" style="width:50px">
                                                <i class="fal mr-1 fa-2x" v-bind:class="{'fa-user':intestatario.FK_ID_PERSONA_FISICA > 0,'fa-university':intestatario.FK_ID_PERSONA_GIURIDICA > 0}"></i>
                                            </div>
                                            <div class="float-left pt-1" style="width:1000px">
                                                <strong>
                                                    {{ intestatario.DENOMINAZIONE }}
                                                </strong>
                                                <br/>
                                                <a :href="'mailto:'+intestatario.EMAIL">{{ intestatario.EMAIL }}</a> {{ intestatario.TELEFONO }} 
                                            </div>
                                            <div class="float-rigt">
                                                <button class="btn btn-danger float-right btn-sm" v-on:click="deleteIntestatario(intestatario);"><i class="fas fa-trash-alt"></i></button>
                                            </div>
                                        </li>
                                    </ul>                                     
                                </div>                            
                            </div>
                        </div>
                        <div class="tab-pane" :id="'allegati'+ts" role="tabpanel">
                            <div class="row w-100 mt-4">
                                <div class="col-12">
                                    <button class="btn btn-success float-right" v-on:click="caricaAllegato()"><i class="fas fa-plus"></i> Carica allegato</button>
                                </div>
                            </div>
                            <div class="row w-100 mt-4">
                                <div class="col-12">
                                    <ul class="list-group">
                                        <li class="list-group-item" v-for="allegato in praticaSelezionata.allegati" v-bind:key="allegato.ID_ALLEGATO">
                                            <div class="col-1 mt-1  ">
                                                <i class="fal fa-file-alt fa-3x"></i> 
                                            </div>
                                            <div class="col-8 mt-1">
                                                <strong>{{ allegato.NOME_FILE }}</strong>
                                                <br/>
                                                <span class="badge badge-info" v-show="allegato.NUMERO_PROTOCOLLO > 0"> PROTOCOLLO {{ allegato.NUMERO_PROTOCOLLO }} / {{ filters.formatDateYear(allegato.DATA_CARICAMENTO) }} - {{ allegato.TIPO ? "USCITA":"ENTRATA" }}</span>
                                                <button class="btn btn-grid btn-primary" v-on:click="generaProtocollo(allegato,0)" v-show="allegato.NUMERO_PROTOCOLLO == 0">Genera protocollo ENTRATA</button>
                                                <button class="btn btn-grid btn-info" v-on:click="generaProtocollo(allegato,1)" v-show="allegato.NUMERO_PROTOCOLLO == 0">Genera protocollo USCITA</button>
                                                <small class="ml-2">Data caricamento: {{ filters.formatDateTime(allegato.DATA_CARICAMENTO) }} {{ allegato.NOTE != '' ? 'NOTE: ' + allegato.NOTE : '' }}</small>
                                            </div>
                                            <div class="col-3 mt-1">
                                                <button v-on:click="deleteAllegato(allegato)"  class="btn btn-danger float-right"><i class="fas fa-trash-alt"></i></button>
                                                <button v-on:click="openAllegato(allegato.ID_ALLEGATO)" class="btn btn-info float-right"><i class="fas fa-folder-open"></i></button>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" :id="'storico'+ts" role="tabpanel" style="overflow:auto;max-height:400px">
                            <div class="timeline mt-4">
                                <div class="timeline-item" style="height:115px" v-for="azione in praticaSelezionata.azioni" v-bind:key="azione.ID_AZIONE">
                                    <div class="timeline-item-marker">
                                        <div class="timeline-item-marker-text" style="width:142px;color:#000;font-weight: bold;">{{filters.formatDateTime(azione.DATA_AZIONE)}}</div>
                                        <div class="timeline-item-marker-indicator bg-primary-soft text-primary" style="border:1px solid"><i class="fal fa-comment"></i></div>
                                    </div>
                                    <div class="timeline-item-content pt-0">
                                        <div class="card shadow-sm">
                                            <div class="card-body">
                                                <h5 style="color:#62106e;font-weight:bold">{{azione.USERNAME}}</h5>
                                                    {{azione.DESCRIZIONE}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" :id="'collegate'+ts" role="tabpanel">
                            <div class="row w-100 mt-4">
                                <div class="col-12">
                                    <button class="btn btn-success float-right" v-on:click="collegaPratica()"><i class="fas fa-plus"></i> Collega pratica</button>
                                </div>
                            </div>
                            <div class="row w-100 mt-4">
                                <div class="col-12">
                                    <ul class="list-group">
                                        <li class="list-group-item" v-for="pc in praticaSelezionata.praticheCollegate" v-bind:key="pc.ID_PRATICA">
                                            <div class="float-left ml-1" v-on:click="openPraticaCollegata(pc)">
                                                <i class="fa-3x" v-bind:class="pc.ICONA"  style="color:#ffad69"></i>
                                            </div>
                                            <div class="float-left ml-3"  v-on:click="openPraticaCollegata(pc)">
                                                <strong>[{{ pc.ID_PRATICA }}] {{ pc.TITOLO }}</strong>
                                                <br/>
                                                <small>DATA CREAZIONE: {{filters.formatDate(pc.DATA_CREAZIONE)}}</small>                            
                                            </div>
                                            <div class="float-right ml-3">
                                                <button v-on:click="deletePraticaCollegata(pc)"  class="btn btn-danger float-right"><i class="fas fa-trash-alt"></i></button>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" :id="'terreni'+ts" role="tabpanel">
                            <div class="row w-100 mt-4">
                                <div class="col-12">
                                    <button class="btn btn-success float-right" v-on:click="collegaTerreno()"><i class="fas fa-plus"></i> Collega Terreno</button>
                                </div>
                            </div>
                            <div class="row w-100 mt-4">
                                <div class="col-12">
                                    <ul class="list-group">
                                        <li class="list-group-item" v-for="t in praticaSelezionata.terreni" v-bind:key="t.ID_TERRENO">
                                            <div class="float-left ml-1">
                                                <i class="fa-3x" v-bind:class="t.ICONA"  style="color:#ffad69"></i>
                                            </div>
                                            <div class="float-left ml-3">
                                                <strong>[{{ t.ID_APPEZZAMENTO }}] {{ t.LOCALITA }}</strong>
                                                <br/>
                                            </div>
                                            <div class="float-right ml-3">
                                                <button v-on:click="deleteTerrenoCollegato(t)"  class="btn btn-danger float-right"><i class="fas fa-trash-alt"></i></button>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaPratica()"><i class="fa fa-check"></i> Salva</button>
                </div>
            </div>  
        </div>
    </div>

    <div class="modal fade" :id="'popUpAllegato'+ts" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:1000px;"  >
            <div class="modal-content" >
                <div class="modal-header" style="background:#629991">
                    <h4 style="color:#fff" class="modal-title"><i class="fas fa-paperclip fa-fw"></i> Allegato</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="height:550px">
                    <div class="row">
                        <div class="col-6">
                            <form>
                                <div class="form-group">
                                    <label >Note</label>
                                    <textarea class="form-control form-control-sm" rows="11" placeholder="Inserisci le tue note qui..." v-model="argsUpload.NOTE"></textarea>
                                </div>
                                <div class="form-group col-md-12">
                                    <label >Genera contestualmente numero protocollo</label>
                                    <input class="form-control form-control-sm" style="width:20px;height:20px" type="checkbox" v-model="argsUpload.FLG_ASSEGNA_PROTOCOLLO" v-bind:true-value="1" v-bind:false-value="0">
                                </div>
                                <div v-if="argsUpload.FLG_ASSEGNA_PROTOCOLLO" class="form-group col-md-12" style="margin-bottom:.50rem">
                                    <label>Tipologia</label>
                                    <select class="form-control " v-model="argsUpload.TIPO">
                                        <option value="0">ENTRATA</option>
                                        <option value="1">USCITA</option>
                                    </select>
                                </div> 
                            </form>
                        </div>
                        <div class="col-6">
                            <Upload @onsuccess="successCaricamento()" :w="90" :args="argsUpload"></Upload>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- 
    <SchedaPratica v-if="praticaSelezionata.praticheCollegate.length > 0"  :ref="'schedaPratica'" @salvataggio="getPratica()" :arrayStati="arrayStati"></SchedaPratica>
-->


    <div class="modal fade" :id="'popUpPersonaFisica'+ts" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:1000px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header" style="background-color: #226636;">
                    <h4 style="color:#fff" class="modal-title"><i class="fal" :class="personaFisicaSelezionata.SESSO == 1 ? 'fa-male' : (personaFisicaSelezionata.SESSO == 2 ? 'fa-female' : 'fa-user-plus')"></i> {{personaFisicaSelezionata.COGNOME != undefined && personaFisicaSelezionata.NOME != undefined ? personaFisicaSelezionata.COGNOME +'  '+ personaFisicaSelezionata.NOME : ''}}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" >
                    <PersonaFisica  v-model="personaFisicaSelezionata"></PersonaFisica>       
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaPersonaFisica()"><i class="fa fa-check"></i> Salva</button>
                </div>
            </div>  
        </div>
    </div>


    <div class="modal fade" :id="'popUpPersonaGiuridica'+ts" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:1000px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header" style="background-color: #3D519C;">
                    <h4 style="color:#fff" class="modal-title"><i class="fal fa-university"></i> {{personaGiuridicaSelezionata.DENOMINAZIONE}}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" style="height:320px">
                    <PersonaGiuridica  v-model="personaGiuridicaSelezionata"></PersonaGiuridica>       
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaPersonaGiuridica()"><i class="fa fa-check"></i> Salva</button>
                </div>
            </div>  
        </div>
    </div>
</template>

<script>

import Upload from '@/components/utils/Upload.vue'
import SchedaPratica from '../components/SchedaPratica.vue'
import PersonaFisica from '../components/common/PersonaFisica.vue';
import PersonaGiuridica from '../components/common/PersonaGiuridica.vue';


export default {
    name:"SchedaPratica",
    props:['arrayStati','praticaCorrente'],
    emits:['salvataggio','cambiaPratica'],
    components:{
        Upload,
        PersonaFisica,
        PersonaGiuridica
        //SchedaPratica
    },
    data:function(){
        return{
            filters:global.filters,
            searchIntestatari:  {
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:5000},
                DENOMINAZIONE:{TYPE:'TEXT',VALUE:''},                
            },
            searchIntestatariSelezionabili:  {
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:5000},
                DENOMINAZIONE:{TYPE:'TEXT',VALUE:''},                
            },
            searchPraticheCollegabili:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:5000},
                TITOLO:{TYPE:'TEXT',VALUE:''},                                  
                ID_PRATICA:{TYPE:'TEXT',VALUE:''},                
            },
            searchTerreniCollegabili:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:5000},
                ID_APPEZZAMENTO:{TYPE:'TEXT',VALUE:''},                                  
                LOCALITA:{TYPE:'TEXT',VALUE:''},
                COGNOME:{TYPE:'TEXT',VALUE:''},
                NOME:{TYPE:'TEXT',VALUE:''},                
            },    
            arrayIntestatariSelezionabili : new Array(),
            arrayPraticheCollegabili : new Array(),
            arrayTerreniCollegabili : new Array(),
            praticaSelezionata : {intestatari:new Array(),praticheCollegate:new Array(),terreni:new Array()},
            argsUpload : {modalita:'EMMET_uploadAllegato'},
            ts:new Date().getTime(),
            tipoVisualizzazioneNav:0,
            personaFisicaSelezionata:{},
            personaGiuridicaSelezionata:{},
            activeTab: "generale"
        }
    },
    methods:{
        openPratica : function(idPratica = 0){
            if (idPratica > 0){
                global.utils.get('emmet/pratica',{ID_PRATICA: idPratica},(response)=>{
                    this.praticaSelezionata = utils.clone(response.data);                     
                })
            }
            else{
                this.praticaSelezionata = {ID_PRATICA: idPratica,intestatari:new Array()};
            }
            utils.openModal('popUpPratica'+this.ts); 
        },
        salvaPratica : function(){
            //update
            if(this.praticaSelezionata.ID_PRATICA> 0){
                global.utils.put('/emmet/pratica',this.praticaSelezionata, (response) => {
                    if (response.esito == 0){
                        this.getPratica(this.praticaSelezionata.ID_PRATICA);
                        utils.alert.success(response.messaggio);
                        this.$emit("salvataggio");
                    }
                });
            }else{
            //insert
                global.utils.post('/emmet/pratica',this.praticaSelezionata,(response)=>{
                    if (response.esito == 0){
                        this.getPratica(response.id_inserito);
                        utils.alert.success(response.messaggio);
                        this.$emit("salvataggio");
                    }
                });
            }
            utils.closeModal('popUpPratica'+this.ts); 
        },
        openRicerca : function(){
            this.tipoVisualizzazioneNav = 1;
            global.utils.openNav();
            global.utils.get('/emmet/intestatari/selezionabili',{ID_PRATICA:this.praticaSelezionata.ID_PRATICA},(response)=>{
                this.arrayIntestatariSelezionabili = response.data;
            });
        },
        addIntestatario : function(intestatario) {
            global.utils.post('/emmet/intestatario',{FK_ID_PRATICA:this.praticaSelezionata.ID_PRATICA,FK_ID_PERSONA_FISICA:intestatario.ID_PERSONA_FISICA,FK_ID_PERSONA_GIURIDICA:intestatario.ID_PERSONA_GIURIDICA,NOTE:''},(response)=>{
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    intestatario.SELEZIONATO = 1;
                    this.getPratica(this.praticaSelezionata.ID_PRATICA);
                }
            }); 
        },
        deleteIntestatario : function(intestatario) {
            utils.alert.confirm("Sei sicuro di voler rimuovere questo intestatario?",()=>{
                global.utils.delete('/emmet/intestatario',intestatario,(response)=>{
                    this.getPratica(this.praticaSelezionata.ID_PRATICA);
                });             
            },this.$root);
        },
        caricaAllegato : function(){
            this.argsUpload.FK_ID_PRATICA = this.praticaSelezionata.ID_PRATICA;
            this.argsUpload.NOTE = "";
            this.argsUpload.FLG_ASSEGNA_PROTOCOLLO = 0;
            this.argsUpload.TIPO = 0;
            utils.openModal('popUpAllegato'+this.ts);
        },
        successCaricamento : function(){
            this.getPratica(this.praticaSelezionata.ID_PRATICA);
            utils.closeModal('popUpAllegato'+this.ts);
        },
        deleteAllegato : function(allegato){
            utils.alert.confirm("Sei sicuro di voler rimuovere questo allegato?",()=>{
                global.utils.delete('/emmet/allegato',allegato,(response)=>{
                    this.getPratica(this.praticaSelezionata.ID_PRATICA);
                });             
            },this.$root);
        },

        generaProtocollo : function(allegato,tipo){
            utils.alert.confirm("Sei sicuro di voler generare il numero di protocollo per questo allegato?",()=>{
                allegato.TIPO = tipo;
                global.utils.put('/emmet/allegato/generaprotocollo',allegato,(response)=>{
                    this.getPratica(this.praticaSelezionata.ID_PRATICA);
                });             
            },this.$root);
        },
        

        openAllegato : function(idAllegato){
            window.open(global.utils.BASE_API + "core/report?ID_REPORT=1001&ID_ALLEGATO="+idAllegato+"&SESSION_TOKEN="+utils.SESSION_TOKEN);
        },
        getPratica : function(){
            global.utils.get('emmet/pratica',{ID_PRATICA: this.praticaSelezionata.ID_PRATICA},(response)=>{
                this.praticaSelezionata = utils.clone(response.data);                     
            });
        },
        collegaPratica : function(){
            this.tipoVisualizzazioneNav = 2;
            global.utils.openNav();
            global.utils.get('emmet/pratiche/collegabili',{ID_PRATICA: this.praticaSelezionata.ID_PRATICA},(response)=>{
                this.arrayPraticheCollegabili = utils.clone(response.data);                     
            });            
        },
        addPraticaCollegata : function(pratica){
            global.utils.post('emmet/praticacollegata',{ID_PRATICA: this.praticaSelezionata.ID_PRATICA,FK_ID_PRATICA:pratica.ID_PRATICA},(response)=>{
                if (response.esito == 0){
                    pratica.SELEZIONATO = 1;
                    this.getPratica();
                }
            });
        },
        deletePraticaCollegata : function(pratica){
            utils.alert.confirm("Sei sicuro di voler rimuovere questo collegamento?",()=>{
                global.utils.delete('emmet/praticacollegata',{ID_PRATICA: this.praticaSelezionata.ID_PRATICA,FK_ID_PRATICA:pratica.ID_PRATICA},(response)=>{
                    if (response.esito == 0){
                        this.getPratica();
                    }
                });
            },this.$root);
        },
        openPraticaCollegata : function(pratica){
            $('#collegate'+this.ts).removeClass("active");  
            $('#generale'+this.ts).tab('show');  
            $('#linkgenerale'+this.ts).tab('show');
            this.$emit("cambiaPratica",pratica.ID_PRATICA); 
        },
        nuovaPersonaFisica : function(){
            this.personaFisicaSelezionata = {ID_PERSONA_FISICA:0};
            utils.openModal('popUpPersonaFisica'+this.ts);

        },
        salvaPersonaFisica : function(){
            global.utils.post('/emmet/persona_fisica',this.personaFisicaSelezionata,(response)=>{
                if (response.esito == 0){
                    utils.closeModal('popUpPersonaFisica'+this.ts);
                    global.utils.post('/emmet/intestatario',{FK_ID_PRATICA:this.praticaSelezionata.ID_PRATICA,FK_ID_PERSONA_FISICA:response.id_inserito,FK_ID_PERSONA_GIURIDICA:0,NOTE:''},(response)=>{
                        if (response.esito == 0){
                            utils.alert.success(response.messaggio);
                            this.getPratica(this.praticaSelezionata.ID_PRATICA);
                        }
                    }); 
                }
            });            
        },
        nuovaPersonaGiuridica : function(){
            this.personaGiuridicaSelezionata = {ID_PERSONA_GIURIDICA:0};
            utils.openModal('popUpPersonaGiuridica'+this.ts);
        },
        salvaPersonaGiuridica : function(){
            global.utils.post('/emmet/persona_giuridica',this.personaGiuridicaSelezionata,(response)=>{
                if (response.esito == 0){
                    var modal = utils.closeModal('popUpPersonaGiuridica'+this.ts);
                    global.utils.post('/emmet/intestatario',{FK_ID_PRATICA:this.praticaSelezionata.ID_PRATICA,FK_ID_PERSONA_FISICA:0,FK_ID_PERSONA_GIURIDICA:response.id_inserito,NOTE:''},(response)=>{
                        if (response.esito == 0){
                            utils.alert.success(response.messaggio);
                            this.getPratica(this.praticaSelezionata.ID_PRATICA);
                        }
                    }); 
                }
            });
            
        },
        collegaTerreno: function(){
            this.tipoVisualizzazioneNav = 3;
            global.utils.openNav();
            global.utils.get('emmet/terreni/collegabili',{ID_PRATICA: this.praticaSelezionata.ID_PRATICA},(response)=>{
                this.arrayTerreniCollegabili = utils.clone(response.data);                     
            }); 
        },
        deleteTerrenoCollegato : function(terreno){
            utils.alert.confirm("Sei sicuro di voler rimuovere questo collegamento?",()=>{
                console.log(this.praticaSelezionata.ID_PRATICA)
                global.utils.delete('emmet/terrenocollegato',{ID_PRATICA: this.praticaSelezionata.ID_PRATICA,FK_ID_TERRENO:terreno.ID_TERRENO},(response)=>{
                    if (response.esito == 0){
                        this.getPratica();
                    }
                });
            },this.$root);
        },
        addTerrenoCollegato : function(terreno){
            global.utils.post('emmet/terrenocollegato',{ID_PRATICA: this.praticaSelezionata.ID_PRATICA,FK_ID_TERRENO:terreno.ID_TERRENO},(response)=>{
                console.log(response.esito);
                if (response.esito == 0){
                    terreno.SELEZIONATO = 1;
                   this.getPratica();
                //    alert("pippo");
                }
            });
        },

    },
    computed:{
        paginatedListIntestatari(){
            var arr = utils.inGrid(this.praticaSelezionata.intestatari,this.searchIntestatari);
            return arr;
        }, 
        paginatedListSelezionabili(){
            var arr = utils.inGrid(this.arrayIntestatariSelezionabili,this.searchIntestatariSelezionabili);
            return arr;
        }, 
        paginatedListPratiche(){
            var arr = utils.inGrid(this.arrayPraticheCollegabili,this.searchPraticheCollegabili);
            return arr;
        }, 
        paginatedListTerreni(){
            var arr = utils.inGrid(this.arrayTerreniCollegabili,this.searchTerreniCollegabili);
            return arr;
        }, 
    }
}
</script>

